<template>
  <!-- 注意事项 -->
  <div>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="800" center>
      <div class="list">
        <div class="row" v-for="(item, index) in list" :key="index">
          <div class="item" v-if="name == '' || name == item.typeName">
            <div class="name">{{ item.typeName }}:</div>
            <div class="text">{{ item.notice_content }}</div>
            <div class="file">
              <a :href="item.file" target="_blank" rel="noopener noreferrer" v-if="item.file" title="点击下载">
                <i class="el-icon-folder-checked"></i>
              </a>
            </div>+
            <div class="img">
              <el-image :src="item.image1" alt="" v-if="item.image1" :preview-src-list="[item.image1]">
              </el-image>
              <el-image :src="item.image2" alt="" v-if="item.image2" :preview-src-list="[item.image2]">
              </el-image>
              <el-image :src="item.image3" alt="" v-if="item.image3" :preview-src-list="[item.image3]">
              </el-image>
            </div>
          </div>
        </div>

      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      title: '',
      list: [],
      name: ''// name空的显示全部 
    };
  },
  created() {
    // this.$api.
  },
  methods: {
    getNotice(user_id, title, name) {
      this.title = title
      this.$api.clienteleApi.getNotice({ user_id }).then(res => {
        res.data.forEach(item => {
          if (item.typeGroup == title) {
            this.list = item.items
          }
        })
        // name 发票编辑用
        let notice_content
        if (name) {
          this.name = name
          notice_content = this.list.find(item => item.typeName == name).notice_content
          if (notice_content) {
            this.dialogVisible = true
          }
        } else {
          let flag = this.list.some(item => item.notice_content != '')
          this.dialogVisible = flag
        }

      })
    }

  }
}
</script>
<style lang='scss' scoped>
.item {
  display: flex;
  padding: 10px 0;
  border-bottom: 1px solid #ccc;

  div {
    display: flex;
    // justify-content: center;
    align-items: center;
  }

  .name {
    width: 100px;
  }

  .text {
    flex: 1;
    color: #B4272D;
  }

  .file {
    width: 50px;

    i {
      font-size: 30px;
    }
  }

  .img {
    width: 200px;

    .el-image {
      width: 60px;
      margin-right: 10px;
      height: 60px;
      border-radius: 4px;
      cursor: pointer;

      &:nth-last-child(1) {
        margin-right: 0;
      }
    }
  }

}
</style>